import CarouselSection from "./CarouselSection";

const ManufacturingFacility = () => {
  const images = [
    "/img/manufacturing_facility/1.png",
    "/img/manufacturing_facility/2.png",
    "/img/manufacturing_facility/3.png",
    "/img/manufacturing_facility/4.png",
    "/img/manufacturing_facility/5.png",
  ];

  const description = `Our zero-discharge, zero-emission manufacturing facility in India is designed with sustainability and precision at its core. The facility features dedicated fermentation trains for each product class, supported by advanced PLC and SCADA systems for full process control and monitoring. With both solid-state and submerged fermentation capabilities, we ensure optimal conditions for consistent product quality.`;

  const popupParagraphs = [
    `Our zero-discharge, zero-emission manufacturing facility in India is designed with sustainability and precision at its core. The facility features dedicated fermentation trains for each product class, supported by advanced PLC and SCADA systems for full process control and monitoring. With both solid-state and submerged fermentation capabilities, we ensure optimal conditions for consistent product quality.`,
    `Our upstream infrastructure includes aerobic and anaerobic fermentation under various parameters, while the downstream processes are equipped with high-speed centrifugation, ultra-filtration, spray drying, lyophilization, encapsulation, and automated blending and packaging. These integrated systems enable us to produce a wide range of formulations in various forms and pack sizes.`,
    `We maintain complete control over the entire production cycle, allowing us to deliver end-to-end solutions tailored to client needs. Our commitment to continuous technological upgrades ensures that our facility remains state-of-the-art, capable of adapting to evolving market demands and customer expectations.`,
  ];

  return (
    <CarouselSection
      title="Manufacturing Facility"
      description={description}
      popupTitle="Manufacturing Facility"
      popupParagraphs={popupParagraphs}
      images={images}
      imagePosition="right"
      rightBgStyle={{
        backgroundImage:
          "linear-gradient(90.95deg, rgba(19, 106, 133, 0.9) 0%, rgba(0, 163, 212, 0.9) 87.52%)",
      }}
    />
  );
};

export default ManufacturingFacility;
